import Image from 'next/image';
import React, { useContext, useEffect, useState } from 'react';
import { AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import { putSocialLink as putWebsiteLink } from '../../../../apis/profile.api';
import * as ProfileInterface from '../../../../interfaces/profile.interface';
// social link data
import { handleSubmitForm } from '../../../../common/formCallApi';
import { renderSubmitFormContent } from '../../../../common/formCommonFunc';
import {
  listIconContact,
  listIconSocialLink,
  socialMediaUrls,
} from '../../../../constant/user-setting-modal-resources';
import { checkLinkConvention } from '../../../../helpers/validate';
import AuthContext from '../../../../state/auth/AuthContext';
import { useModal } from '../../../../state/modal-provider/ModalProvider';
// components inside contact-bar folder
import WebsiteInput from './WebsiteInput';
const requiredKeys = ['link'];

const ContactBar: React.FunctionComponent<
  ProfileInterface.IContactBarProps
> = ({
  roleView,
  social,
  contact,
  website,
  setIsContactModalShown,
  refectAfterChangeInformation,
}) => {
  const { setLoading } = useContext(AuthContext);
  const { toast } = useModal();

  const [isSeelAllWebsite, setIsSeeAllWebsite] = useState<boolean>(false);

  const handleSubmit = async (
    event: React.FormEvent<HTMLFormElement>,
    id: string,
    website: ProfileInterface.IWebsiteLink
  ) => {
    event.preventDefault();
    handleSubmitForm({
      callback: () => {},
      extraValidate: () => checkLinkConvention(website.link),
      requiredKeys,
      data: website,
      id: id,
      asyncFunc: putWebsiteLink,
      formCancelCallBack: () => {},
      toggleSuccessModalNoti: () => {
        toast.success({
          content: renderSubmitFormContent(id),
        });
        refectAfterChangeInformation();
      },
      toggleErrorModalNoti: () =>
        toast.error({
          content: 'Có lỗi xảy ra, vui lòng thử lại.',
        }),
      setLoading,
    });
    setLoading(false);
  };

  return (
    <div>
      <div className="group-one flex">
        <div className="flex pr-2">
          {social.map((item: ProfileInterface.ISocialLink, index: number) => {
            return (
              <div key={index} className="group-two relative">
                {/* tooltip*/}
                <div
                  className={`hidden group group-two-hover:block absolute top-0 ml-[-160%] mt-[-40px]`}
                >
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noreferrer"
                    className="cursor-pointer flex min-w-[300px] bg-[#FEFEFE] border rounded-lg p-[10px]"
                  >
                    <Image
                      src={'/icons/hyperlink-blue.svg'}
                      alt="hyperlink icon"
                      width={17}
                      height={17}
                    />
                    <p className="group-hover:underline max-w-[200px] ml-1 whitespace-nowrap text-ellipsis overflow-hidden text-primary pr-[10px]">
                      {item.link}
                    </p>
                    <p className="hover:text-primary">Đi tới</p>
                  </a>
                </div>
                <a href={item.link} target="_blank" rel="noreferrer">
                  <span className="mt-2 inline-block w-[36px]">
                    {listIconSocialLink.map(({ icon, name }, index) =>
                      name ===
                      socialMediaUrls[parseInt(item.socialNetwork)]?.name ? (
                        <p
                          key={index}
                          className="text-primary text-lg flex justify-center items-center"
                        >
                          {icon}
                        </p>
                      ) : undefined
                    )}
                  </span>
                </a>
              </div>
            );
          })}
        </div>

        <div className="flex">
          {contact.map((item: ProfileInterface.IContact, index: number) => {
            return (
              <div className="group-two relative" key={index}>
                {/* tooltip */}
                <div className="hidden group-two-hover:block group absolute top-0 ml-[-150%] mt-[-40px]">
                  {parseInt(item.contactType) === 0 ||
                  parseInt(item.contactType) === 2 ? (
                    <a
                      href={`tel:${item.contactInfo}`}
                      target="_blank"
                      rel="noreferrer"
                      className="cursor-pointer flex w-min-[212px] bg-[#FEFEFE] border rounded-lg p-[10px]"
                    >
                      <p className="group-hover:underline text-primary pr-[20px]">
                        {item.contactInfo}
                      </p>
                      <div className="hover:text-primary">Gọi</div>
                    </a>
                  ) : (
                    <a
                      href={`mailto:${item.contactInfo}`}
                      target="_blank"
                      rel="noreferrer"
                      className="cursor-pointer flex w-min-[212px] bg-[#FEFEFE] border rounded-lg p-[10px]"
                    >
                      <p className="group-hover:underline text-primary pr-[20px]">
                        {item.contactInfo}
                      </p>
                      <div className="hover:text-primary">Email</div>
                    </a>
                  )}
                </div>
                <a
                  href={`${
                    parseInt(item.contactType) === 0 ||
                    parseInt(item.contactType) === 2
                      ? `tel`
                      : `mailto`
                  }:${item.contactInfo}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="mt-2 inline-block w-[36px]">
                    {listIconContact.map(({ icon }, index) =>
                      index === parseInt(item.contactType) ? (
                        <p
                          key={index}
                          className="text-primary text-lg flex justify-center items-center w-[24px]"
                        >
                          {icon}
                        </p>
                      ) : undefined
                    )}
                  </span>
                </a>
              </div>
            );
          })}
        </div>

        {roleView == ProfileInterface.RoleViewEnum.Owner &&
          (contact.length > 0 || social.length > 0 ? (
            <button
              className={`group-one-hover:block hidden`}
              onClick={() => {
                setIsContactModalShown(true);
              }}
            >
              <AiOutlineEdit className="text-primary text-[24px]" />
            </button>
          ) : (
            <div
              className="cursor-pointer py-2 flex items-center gap-2"
              onClick={() => {
                setIsContactModalShown(true);
              }}
            >
              <div className="bg-blur_primary rounded-full p-2">
                <AiOutlinePlus className="text-primary text-[16px]" />
              </div>
              <p className="text-primary">
                Thêm <span className="hidden lg:inline-block">tài khoản</span>{' '}
                mạng xã hội
              </p>
            </div>
          ))}
      </div>

      <div className="flex items-start flex-col">
        {(isSeelAllWebsite ? website : website?.slice(0, 4) ?? []).map(
          // take first 5
          (item: any, index: number) => {
            return (
              <WebsiteInputMiddleware
                key={index}
                item={item}
                handleSubmit={handleSubmit}
                roleView={roleView}
              />
            );
          }
        )}
        {!isSeelAllWebsite && website?.length > 5 && (
          <p
            className="text-sm text-[#0086C9] hover:underline cursor-pointer self-center mt-2"
            onClick={() => setIsSeeAllWebsite(true)}
          >
            Xem thêm
          </p>
        )}
      </div>
    </div>
  );
};

function WebsiteInputMiddleware({
  item,
  handleSubmit,
  roleView,
}: {
  item: any;
  handleSubmit: Function;
  roleView: ProfileInterface.RoleViewType;
}) {
  const [isWebsiteEditable, setIsWebsiteEditable] = useState<boolean>(false);
  useEffect(() => {
    window &&
      window.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e?.key && e?.key === 'Escape') {
          setIsWebsiteEditable(false);
        }
      });

    return () => {
      window && window.addEventListener('keydown', () => {});
    };
  }, []);

  return (
    <div className="group flex items-center">
      <WebsiteInput
        website={item}
        handleSubmit={handleSubmit}
        isWebsiteEditable={isWebsiteEditable}
        setIsWebsiteEditable={setIsWebsiteEditable}
      />
      {roleView == ProfileInterface.RoleViewEnum.Owner && (
        <button
          className={`${
            isWebsiteEditable ? '' : 'group-hover:visible'
          } invisible`}
          onClick={() => {
            setIsWebsiteEditable(!isWebsiteEditable);
          }}
        >
          <AiOutlineEdit className="text-primary text-[24px]" />
        </button>
      )}
    </div>
  );
}

export default ContactBar;
